import React from 'react';
import RadarChart from './graph_components/RadarChart';
import SelectedActorsScores from './graph_components/ActorScoreBoard';
import CBSScore from './graph_components/CBSScoreChart';
import ProjectScoreSummaryChart from './graph_components/ProjectScoreSummaryChart';
import WaterFootprintGraph from './graph_components/WaterFootprintGraph';
import MapComponent from './graph_components/MapFootprint';
import WaterUsageChart from './graph_components/WaterUsageChart';
import AdvanceButton from '../other_components/AdvanceButton';

/**
 * LE BILAN D'UN ATELIER BTP.
 *
 * Coque commune aux écrans à graphiques (`.board-*`, App.css), et trois
 * sections qui suivent la lecture qu'en fait l'animateur : le projet, ses
 * consommations phase par phase, puis la table.
 *
 * L'écran reste DURCI — métriques, phases et image de fond sont écrites ici et
 * non dans `content.metadata` (cf. CLAUDE.md, « en sursis ») : la mise en page
 * est reprise, le contenu ne bouge pas.
 */
const SELECTED_METRICS = ['rentabilite', 'satisfaction-usager', 'simplicite-technique',
                          'assurabilite', 'sobriete-carbone'];

const PHASES = [
  { icon: "/icon/materiaux.png", title: "Matériaux", keyDic: "materiaux-waterfootprint" },
  { icon: "/icon/chantier.png", title: "Chantier", keyDic: "chantier-waterfootprint" },
  { icon: "/icon/exploitation.png", title: "Exploitation", keyDic: "exploitation-waterfootprint" },
];

const BACKGROUND = 'https://res.cloudinary.com/dc1felxem/image/upload/v1740671404/hydros90_22124_Sustainable_residential_building_with_eco-frie_0f7eaff6-5480-430a-93d2-4bd13a94ba60_0_ph8ncb.jpg';

const BTPEndPage = ({ pageData, gameStatus, onDecisionSelect,
                      displayButton = true, endsGame = false }) => {
  const scores = gameStatus.score_dic;

  if (!scores) {
    return <div className="score-board-loading">Chargement des scores…</div>;
  }

  return (
    <div className="page-general-container">
      <div className='page-general-background-color'></div>

      <div className='page-general-background-hero' style={{ backgroundImage: `url(/img/bgrille-m.svg)` }}>
          <div className='page-general-background-image' style={{ backgroundImage: `url(${BACKGROUND})` }}></div>
      </div>

      <div className='page-main-content'>
        <div className="board-page">
          <header className="board-head">
            <h1 className="board-title">{pageData?.title || 'Le bilan de votre projet'}</h1>
          </header>

          <h2 className="board-section">Le projet</h2>
          <div className="board-grid">
            <section className="board-card board-card--wide">
              <ProjectScoreSummaryChart gameStatus={gameStatus} />
            </section>

            <section className="board-card">
              <WaterFootprintGraph gameStatus={gameStatus} />
            </section>

            <section className="board-card">
              <CBSScore gameStatus={gameStatus} />
            </section>

            <section className="board-card board-card--wide">
              <MapComponent />
            </section>
          </div>

          <h2 className="board-section">Les consommations, phase par phase</h2>
          {/* La consigne une fois pour les trois cartes : répétée dans chacune,
              elle prenait plus de place que ce qu'elle explique. */}
          <p className="board-section-hint">
            Répartition des consommations d'eau, projet standard contre Aquacité.
          </p>
          <div className="board-grid">
            {PHASES.map((phase) => (
              <section key={phase.keyDic} className="board-card board-card--wide board-card--titled">
                <div className="score-board-icon-and-title">
                  <img className="water-footprint-phase-icon" src={phase.icon} alt="" />
                  <h3 className="board-card-title">{phase.title}</h3>
                </div>
                {/* Les deux intitulés sont ceux du graphe (`title`) et non des
                    titres posés au-dessus : la boîte du donut se centre sur sa
                    hauteur, et un titre extérieur se retrouvait à cent pixels
                    du dessin qu'il nommait. */}
                <div className="score-board-two-graphs">
                  <WaterUsageChart
                    title="Projet standard"
                    data={scores[phase.keyDic].metadata.standard}
                    unit="m³"
                    totalInitConsumption={scores[phase.keyDic].standard_value} />
                  <WaterUsageChart
                    title="Aquacité"
                    data={scores[phase.keyDic].metadata.current}
                    unit="m³"
                    totalInitConsumption={scores[phase.keyDic].standard_value} />
                </div>
              </section>
            ))}
          </div>

          <h2 className="board-section">Les acteurs</h2>
          <div className="board-grid">
            <section className="board-card board-card--wide">
              <SelectedActorsScores gameStatus={gameStatus} podium={true} />
            </section>
            <section className="board-card board-card--wide">
              <RadarChart gameStatus={gameStatus} selectedMetrics={SELECTED_METRICS}
                          width="100%" height="420px" />
            </section>
          </div>

          <div className="board-actions">
            <AdvanceButton
              pageData={pageData}
              onDecisionSelect={onDecisionSelect}
              displayButton={displayButton}
              endsGame={endsGame}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BTPEndPage;
